module.exports = __webpack_public_path__ + "media/assets/images/flags/mz-b3211c86ee793ea29565b586855c6104.svg";